import { useRoles } from "api/roles";
import { Breadcrumbs, TopHeader } from "components/Header/TopHeader/TopHeader";
import { useMessage } from "hooks/intl";
import "react-loading-skeleton/dist/skeleton.css";
import { useParams } from "react-router-dom";
import { links } from "utilities/links";
import { RoleForm } from "./RoleForm";
import { useStyles } from "./RoleForm.styles";

export function EditRole() {
  const classes = useStyles();
  const { message } = useMessage();
  const { useRoleData } = useRoles();
  const { id: roleID } = useParams<{ id: string }>();

  const { data: roleData } = useRoleData(roleID as string);

  const breadcrumbs: Breadcrumbs = {
    parent: {
      label: message({ id: "roles" }),
      path: links.settings,
    },
  };

  return (
    <>
      <TopHeader
        breadcrumbs={breadcrumbs}
        clearLink={links.settings}
        title={roleData && `${message({ id: "editRole" })} "${roleData?.name}"`}
      />
      <div className={classes.formWrapper}>
        <RoleForm editMode initialValues={roleData} />
      </div>
    </>
  );
}
